<template>
  <div class="category-list-section" :class="{collapsed: viewCollapsed}" v-show="shouldShowCategory">
    <div class="category-title" @click="titleClicked">
      <div class="arrow" v-if="!draggingCategories" key="arrow"/>
      <div class="handle" v-else key="handle"/>
      <h3><input type="text" class="input-bg" :disabled="!draggingCategories" v-model="categoryName"></h3>
    </div>
    <transition name="category">
      <div v-show="!viewCollapsed && !draggingCategories" :key="reRenderIterator">
        <draggable v-model="items"
                   :move="dragMoved"
                   ghost-class="ghost"
                   :sort="true"
                   tag="div"
                   :animation="0"
                   handle=".handle"
                   dragClass="drag-item"
                   group="listItem"
                   @end="dragEnded"
        >
<!--          <transition-group tag="ul" name="list">-->
            <list-item v-for="item in items" :item="item" :key="item.id"/>
<!--          </transition-group>-->
        </draggable>
      </div>
    </transition>
  </div>
</template>
<script>
  import ListItem from '@/components/ListItem'
  import { mapActions, mapState } from 'vuex'
  import draggable from 'vuedraggable'

  export default {
    name: 'category-list-section',
    components: {ListItem, draggable},
    props: {
      category: {
        type: Object,
        required: true
      }
    },
    data () {
      return {
        collapsed: false,
        reRenderIterator: 0
      }
    },
    computed: {
      ...mapState(['currentQuery', 'editing', 'draggingCategories', 'checkedItemsVisible']),
      queried () {
        return this.currentQuery && this.category.items.filter(i => i.name.toLowerCase().indexOf(this.currentQuery.toLowerCase() !== -1)).length
      },
      viewCollapsed () {
        return this.collapsed && !this.queried
      },
      items: {
        get () {
          return this.editing ? this.category.items :
            [
              ...this.category.items
                .filter(a => !a.checked)
                .sort((a, b) => a.index - b.index),

              ...this.category.items
                .filter(a => a.checked)
                .sort((a, b) => a.index - b.index)
            ]
        },
        set () {
          // force re-render
          this.reRenderIterator++
        }
      },
      categoryName: {
        get () {
          return this.category.name
        },
        set (name) {
          this.setCategoryName({id: this.category.id, name})
        }
      },
      shouldShowCategory () {
        if (this.checkedItemsVisible) {
          return this.items.length > 0
        } else if (this.queried > 0)
          return true
        else {
          return this.items.filter(i => !i.checked).length
        }
      }
    },
    methods: {
      ...mapActions(['setListItemIndex', 'swapListItemsIndexes', 'setCategoryItems', 'setCategoryName', 'setListItemCategory']),
      titleClicked () {
        if (!this.draggingCategories) {
          this.collapsed = !this.collapsed
        }
      },
      dragMoved ({draggedContext, relatedContext}) {
        const id1 = draggedContext.element.id
        const id2 = relatedContext.element.id
        console.log(draggedContext, relatedContext)

        if (draggedContext.element.categoryID !== relatedContext.element.categoryID) {
          this.setListItemCategory({id: id1, categoryID: relatedContext.element.categoryID})
          this.swapListItemsIndexes({id1, id2})
        } else {
          this.swapListItemsIndexes({id1, id2})
        }

        return true
      },
      dragEnded (event) {
        console.log(event)
      }
    },
  }
</script>
<style scoped lang="sass">
  .category-title
    position: -webkit-sticky
    position: sticky
    top: $size-64
    background-color: $white
    padding: $size-12 0
    margin-top: $size-12
    font-weight: 700
    display: flex
    align-items: center
    z-index: 3
    margin-right: -$size-12
    margin-left: -$size-12
    padding-right: $size-12
    padding-left: $size-12
    user-select: none
    -webkit-user-select: none
    +background-blur($white, 16px, .26, $filters: saturate(1.8))

    +dark
      +background-blur($black, 16px, .26, $filters: saturate(1.8))

    h3
      width: 100%

      input
        +dark
          color: transparentize($white, .08)

    .arrow
      width: .6em
      height: .6em
      position: relative
      margin-left: $size-12
      margin-right: calc(#{$size-16 + $size-6} - .6em)
      transition: $transition-quick
      transform: translateY(-25%)

      &:after
        content: ''
        border: solid 1gem $black
        border-top-color: transparent
        border-left-color: transparent
        transform: rotate(45deg)
        +full-size-absolute

        +dark
          border-bottom-color: transparentize($white, .75)
          border-right-color: transparentize($white, .75)

  .collapsed
    .arrow
      transform: rotate(90deg)

  // fix for sortablejs using incorrect transform: matrix(...)
  // use ghost rules for drag-item if this is fixed
  .drag-item
    opacity: 0 !important //1

  .ghost
    opacity: 1
    transition: $transition-quick
    transform: scale(1.05)

    .category-title
      box-shadow: 0 0 16gem rgba(0,0,0,.15)
      border-radius: $item-radius
      right: 0

    li
      display: none

    input
      background-color: transparent !important
</style>
